// Map raw Firebase auth error codes to plain-language, on-brand copy. A non-
// technical alpha tester must never see a raw "Firebase: Error (auth/...)"
// string, so anything not explicitly mapped falls through to a generic
// reassurance rather than leaking err.message.
export const friendlyAuthError = (err) => {
  switch (err?.code) {
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found":
      return "Incorrect email or password.";
    case "auth/email-already-in-use":
      return "An account with this email already exists. Try logging in instead.";
    case "auth/weak-password":
      return "Password must be at least 6 characters.";
    case "auth/invalid-email":
      return "That doesn't look like a valid email address.";
    case "auth/too-many-requests":
      return "Too many attempts. Please wait a moment and try again.";
    case "auth/network-request-failed":
      return "Couldn't reach the server. Check your connection and try again.";
    case "auth/user-disabled":
      return "This account has been disabled. Contact support if you think that's a mistake.";
    case "auth/missing-password":
      return "Enter your password.";
    case "auth/internal-error":
      return "Something went wrong on our end. Please try again in a moment.";
    case "auth/expired-action-code":
      return "This link has expired. Request a new one and try again.";
    case "auth/invalid-action-code":
      return "This link has already been used or is invalid. Request a new one and try again.";
    default:
      return "Something went wrong. Please try again.";
  }
};
